import {connect} from 'react-redux';
import * as notificationsActions from '../../actions/notifications';
import InvitationRejectionReasonForm from './InvitationRejectionReasonForm';

const mapDispatchToProps = dispatch => ({
  rejectSuggection: (invitationId, rejectionReason) => dispatch(notificationsActions.rejectSuggestion(invitationId, rejectionReason))
});

export default connect(null, mapDispatchToProps)(InvitationRejectionReasonForm);
